import { ifAuthenticated } from '@/router/before'
import Config from '@/config/default/config'

export const authRouteNames = {
  AuthMainRoute: 'AuthMainRoute',
  LogoutRoute: 'LogoutRoute'
}
const rn = authRouteNames

export const authRouteURLs = {
  [rn.AuthMainRoute]: Config.routing.authPage.path,
  [rn.LogoutRoute]: '/logout'
}
export const authPages = [
  {
    path: authRouteURLs[rn.AuthMainRoute],
    name: rn.AuthMainRoute,
    meta: {
      sidebar: null,
      navbar: {
        group: Config.systemTitle.fullName,
        displayName: Config.routing.authPage.name
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "AuthMainRoute" */ '@/views/auth/AuthMainRoute.vue'
      )
  },
  {
    path: authRouteURLs[rn.LogoutRoute],
    name: rn.LogoutRoute,
    meta: {
      sidebar: null,
      navbar: {
        group: Config.systemTitle.fullName,
        displayName: 'Выход'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "LogoutRoute" */ '@/views/auth/LogoutRoute.vue'
      )
  }
]
